<div class="card panel-flat-color primary-panel select-entity">
    <div class="panel-flat-header mb-0"
         [class.pointer]="collapsible"
         (click)="collapsible && toggleBody()">
        @if (collapsible) {
            <panel-chevron [showBody]="showBody"></panel-chevron>
        }
        <div class="header-icon"><i class="fa fa-building-o"></i></div>
        <h3>{{ headerText }}</h3>
        @if (hasInactiveEntities) {
            <div class="float-end checkbox m-0 mt-1"
                 [class.disabled]="entitySelection.selectedEntities.length > 0"
                 (click)="$event.stopPropagation()">
                <label>
                    <input type="checkbox"
                           [(ngModel)]="entitySelection.excludeInactive"
                           [disabled]="entitySelection.selectedEntities.length > 0"
                           (change)="getTopLevelCompanies()" />
                    Exclude Inactive
                </label>
            </div>
        }
    </div>
    <div class="panel-flat-body" [hidden]="collapsible && !showBody">
        @if (report.reportTypeId === reportTypes.Maar) {
            <div class="checkbox mt-0 mb-3">
                <label>
                    <input type="checkbox" [(ngModel)]="report.criteria.includeAllCompanies" /> Include All Companies
                </label>
            </div>
        }
        <div [hidden]="report.criteria.includeAllCompanies" class="row">
            @if (showSupportInstancePicker) {
                <div class="col-lg-4 col-xl-3 entity-panel">
                    <div class="card panel-flat-color secondary-panel small-panel mb-0">
                        <!-- Default panel contents -->
                        <div class="panel-flat-header small-header">
                            <h3>Support Instances</h3>
                        </div>
                        @if (loadingSupportInstances) {
                            <ws-ace-loader [zIndex]="1"></ws-ace-loader>
                        }
                        <select multiple
                                id="supportInstances"
                                class="entity-list"
                                [class.loading-list]="loadingSupportInstances"
                                (change)="selectedInstanceChanged($event)">
                            @for (instance of supportInstances; track instance) {
                                <option
                                    [selected]="entitySelection.selectedSupportInstanceIds.includes(instance.instanceId)"
                                    [value]="instance.instanceId">
                                    {{ instance.instanceName }}
                                </option>
                            }
                        </select>
                    </div>
                    @if (supportInstances.length) {
                        <div class="float-end">
                            @if (entitySelection.selectedSupportInstanceIds.length !== supportInstances.length) {
                                <button class="ace-btn btn-sm btn-primary" (click)="selectAllSupportInstances()">
                                    Select All
                                </button>
                            }
                            @if (entitySelection.selectedSupportInstanceIds.length === supportInstances.length) {
                                <button class="ace-btn btn-sm btn-primary" (click)="unselectAllSupportInstances()">
                                    Unselect All
                                </button>
                            }
                        </div>
                    }
                </div>
            }
            @if (!hideTopLevelCompanyPicker) {
                <div class="col-lg-4 col-xl-3 entity-panel">
                    <div class="card panel-flat-color secondary-panel small-panel mb-0">
                        <!-- Default panel contents -->
                        <div class="panel-flat-header small-header">
                            <h3>Top Level Companies</h3>
                        </div>
                        @if (loadingTopLevelCompanies) {
                            <ws-ace-loader [zIndex]="1"></ws-ace-loader>
                        }
                        <select multiple
                                id="top-level"
                                class="entity-list"
                                [class.loading-list]="loadingTopLevelCompanies"
                                (change)="selectedTopLevelCompanyOptionsChanged($event)"
                                [disabled]="isAppealResponsibilitySelected()"
                                [scrollToFirstSelected]="topLevelCompanies"
                        >
                            @for (company of topLevelCompanies; track company.companyID) {
                                <option
                                    [value]="company.companyID"
                                    [selected]="isTopLevelCompanySelected(company.companyID)">
                                    {{ company.companyName }}
                                </option>
                            }
                        </select>
                    </div>
                    @if (hasInstancePrivatePermission) {
                        <div class="checkbox d-inline-block align-middle">
                            <label>
                                <input type="checkbox"
                                       [(ngModel)]="report.criteria.frequentlyUsed"
                                       (change)="getTopLevelCompanies()" />
                                Only Frequently Used
                            </label>
                        </div>
                    }
                    @if (topLevelCompanies.length) {
                        <div class="float-end">
                            @if (entitySelection.selectedTopLevelCompanyIDs.length !== topLevelCompanies.length) {
                                <button class="ace-btn btn-sm btn-primary" (click)="selectAllTopLevelCompanies()">
                                    Select All
                                </button>
                            }
                            @if (entitySelection.selectedTopLevelCompanyIDs.length === topLevelCompanies.length) {
                                <button class="ace-btn btn-sm btn-primary" (click)="unselectAllTopLevelCompanies()">
                                    Unselect All
                                </button>
                            }
                        </div>
                    }
                </div>
            }
            @for (selectedEntity of entitySelection.selectedEntities;
                track selectedEntity;
                let i = $index;
                let last = $last;
                let first = $first) {
                <div class="col-lg-4 col-xl-3 entity-panel">
                    <div class="card panel-flat-color secondary-panel small-panel mb-0 position-relative">
                        <!-- Default panel contents -->
                        <div class="panel-flat-header small-header position-relative">
                            <h3>{{ selectedEntity.name }}</h3>
                            <div class="position-absolute end-0" style="top: 2px">
                                @if (selectedEntity.dropdownList.length) {
                                    <select class="form-select form-select-sm entity-dropdown"
                                            [(ngModel)]="selectedEntity.selectedDropdown"
                                            (change)="propCharChanged(selectedEntity, i)">
                                        @for (option of selectedEntity.dropdownList; track option) {
                                            <option [value]="option">{{ option }}</option>
                                        }
                                    </select>
                                }
                                @if (!selectedEntity.dropdownList.length &&
                                (selectedEntity.id === 999 || selectedEntity.id === 998)) {
                                    <em class="me-2">Empty</em>
                                }
                                @if (last && !(first && entitySelection.beginWithStateSource)) {
                                    <i class="fa fa-close mt-1 mx-1 mb-0" (click)="removeLast()"></i>
                                }
                            </div>
                        </div>
                        @if (selectedEntity.loading) {
                            <ws-ace-loader [zIndex]="1"></ws-ace-loader>
                        }
                        @if (selectedEntity.id !== 999 && selectedEntity.id !== 998) {
                            <select multiple
                                    class="entity-list"
                                    [ngModel]="selectedEntity.selectedIDs"
                                    (ngModelChange)="selectedSubEntitiesChanged($event, selectedEntity, i)"
                                    [scrollToFirstSelected]="selectedEntity.list"
                            >
                                @for (genericEntity of selectedEntity.list; track genericEntity) {
                                    <option [class.loading-list]="selectedEntity.loading"
                                            [ngValue]="genericEntity.id">
                                        {{ genericEntity.name }}
                                    </option>
                                }
                            </select>
                        }
                        @if (selectedEntity.id === 999 || selectedEntity.id === 998) {
                            <select multiple
                                    class="entity-list"
                                    [class.loading-list]="selectedEntity.loading"
                                    [ngModel]="selectedEntity.selectedPropCharVals"
                                    (ngModelChange)="selectedSubEntitiesChanged($event, selectedEntity, i)"
                                    [scrollToFirstSelected]="selectedEntity.list"
                            >
                                @for (propCharVal of selectedEntity.list; track propCharVal) {
                                    <option
                                        [ngValue]="propCharVal.name">
                                        {{ propCharVal.name }}
                                    </option>
                                }
                            </select>
                        }
                    </div>
                    @if (selectedEntity.list.length) {
                        <div class="float-end">
                            @if (!areAllSelected(selectedEntity)) {
                                <button class="ace-btn btn-sm btn-primary" (click)="selectAll(selectedEntity, i)">
                                    Select All
                                </button>
                            }
                            @if (areAllSelected(selectedEntity)) {
                                <button class="ace-btn btn-sm btn-primary" (click)="unselectAll(selectedEntity, i)">
                                    Unselect All
                                </button>
                            }
                        </div>
                    }
                </div>
            }
            @if (showAdditionalSelections()) {
                <div class="col-lg-2 additional-selections">
                    <div>
                        <strong>Additional Selections</strong>
                    </div>
                    @for (entity of additionalSelections; track entity; let i = $index) {
                        <div>
                            @if (i < 3 || additionalSelections.length === 4 || showMoreSelections) {
                                <button class="ace-btn btn-primary large-button"
                                        [disabled]="noItemsSelected()"
                                        (click)="selectionButtonClicked(entity.id)">
                                    {{ entity.buttonName }}
                                </button>
                            }
                        </div>
                    }
                    <div>
                        @if (additionalSelections.length > 4 && !showMoreSelections) {
                            <button class="ace-btn btn-primary large-button"
                                    [disabled]="noItemsSelected()"
                                    (click)="showMoreSelections = true">
                                More...
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
        @if (isCsrCommandCenter || showApplyButton) {
            <div class="d-flex justify-content-between mt-3">
                @if (isCsrCommandCenter) {
                    <div class="d-flex align-items-center gap-2">
                        <label class="m-0">Show Values:</label>
                        <select [(ngModel)]="entitySelection.showValues"
                                class="form-select form-select-sm w-auto">
                            <option [ngValue]="0">Top Level Company</option>
                            <option [ngValue]="EntityTypeIds.COMPANY">Top/Subsidiary</option>
                            <option [ngValue]="EntityTypeIds.SITE">Top/Subsidiary/Site</option>
                            <option [ngValue]="EntityTypeIds.PARCEL">Top/Subsidiary/Site/Parcel</option>
                        </select>
                    </div>
                }
                @if (showApplyButton) {
                    <button type="button"
                            class="ace-btn btn-sm btn-primary"
                            [disabled]="!dataLoaded"
                            title="Apply"
                            (click)="apply()">
                        Apply
                    </button>
                }
            </div>
        }
    </div>
</div>
